import React from 'react'
import { MenuItem, Position, ButtonProps } from '@blueprintjs/core'
import { Select2 } from '@blueprintjs/select'
import { Button } from '..'

export interface Month {
  label: string
  value: number
}

export const months: Month[] = [
  { label: 'January', value: 0 },
  { label: 'February', value: 1 },
  { label: 'March', value: 2 },
  { label: 'April', value: 3 },
  { label: 'May', value: 4 },
  { label: 'June', value: 5 },
  { label: 'July', value: 6 },
  { label: 'August', value: 7 },
  { label: 'September', value: 8 },
  { label: 'October', value: 9 },
  { label: 'November', value: 10 },
  { label: 'December', value: 11 },
]

interface MonthSelectProps {
  value: Month | null
  onChange: (month: Month) => void
  buttonProps?: ButtonProps
}

const MonthSelect = Select2<Month>

function MonthSelectWrapper({ value, onChange, buttonProps }: MonthSelectProps) {
  return (
    <MonthSelect
      scrollToActiveItem
      popoverProps={{
        minimal: true,
        position: Position.BOTTOM_RIGHT,
        modifiers: { arrow: { enabled: false } },
      }}
      filterable={false}
      items={months}
      itemRenderer={(month, { handleClick }) => (
        <MenuItem
          key={month.value}
          active={value ? month.value === value.value : false}
          onClick={handleClick}
          text={month.label}
        />
      )}
      onItemSelect={onChange}
    >
      <Button {...buttonProps} text={value ? value.label : '----'} rightIconName="chevron-down" />
    </MonthSelect>
  )
}

export default MonthSelectWrapper
